module.exports = __webpack_public_path__ + "static/images/components/BuildingCardImage/images/cost-bg-disabled.9f90a21e.png";


//////////////////
// WEBPACK FOOTER
// ./components/BuildingCardImage/images/cost-bg-disabled.png
// module id = 2565
// module chunks = 11